import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const kiosk_token = localStorage.getItem('kiosk_token');
        if (kiosk_token) {
            const cleanToken = kiosk_token.replace(/^"(.*)"$/, '$1');
            config.headers.Authorization = `Bearer ${cleanToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // TEMP: skip forced logout while auth bypass is on
        const bypassAuth = String(process.env.REACT_APP_BYPASS_AUTH || '').toLowerCase() === 'true';
        if (!bypassAuth && error.response?.status === 401) {
            localStorage.removeItem('kiosk_token');
            localStorage.removeItem('patient_profile');
            if (window.location.pathname !== '/') {
                window.location.assign('/');
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
